"use strict";
export var MenuTypes = /* @__PURE__ */ ((MenuTypes2) => {
  MenuTypes2["Workspace"] = "Workspace";
  MenuTypes2["ApplicationEnv"] = "ApplicationEnv";
  MenuTypes2["Project"] = "Project";
  return MenuTypes2;
})(MenuTypes || {});
